import React from "react";
import useLanguageDirection from "../../hooks/useLanguageDirection";

export default function CustomTextArea({
  id,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  icon,
}) {
  const direction = useLanguageDirection();

  return (
    <div className="relative w-full ">
      {/* Arabic Label */}
      {label && (
        <label
          htmlFor={id}
          className="block mb-2 text-sm font-semibold text-gray-700"
          dir={direction}
        >
          {label}
        </label>
      )}
      <div className="relative">
        {/* Optional Icon */}
        {icon && (
          <span className="absolute inset-y-0 left-0 flex items-center text-gray-900">
            {icon}
          </span>
        )}
        {/* Arabic Textarea Field */}
        <textarea
          id={id}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          dir={direction}
          className="w-full px-2 py-2 text-sm text-black bg-white border border-gray-300 rounded-lg md:px-5 sm:text-lg placeholder:text-sm"
        />
      </div>
    </div>
  );
}
